var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "totals-button",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.toggleTotals.apply(null, arguments)
        },
      },
    },
    [
      _c("span", { class: [_vm.iconTotals, "totals-icon"] }),
      _c("span", { staticClass: "toggle-totals-text" }, [
        _vm._v(_vm._s(_vm.totalsText)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }